import { render, staticRenderFns } from "./FileHistory.vue?vue&type=template&id=4c0d63a4&scoped=true"
import script from "./FileHistory.vue?vue&type=script&lang=js"
export * from "./FileHistory.vue?vue&type=script&lang=js"
import style0 from "./FileHistory.vue?vue&type=style&index=0&id=4c0d63a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0d63a4",
  null
  
)

export default component.exports